<div (mouseenter)="onHoverEnter()" (mouseleave)="onHoverExit()" #previewItemContainer class="flex flex-col items-center justify-center bg-transparent text-xs">
        <div class="relative preview-hover group card-shadow mtg-card-rounded-sm sm:mtg-card-rounded overflow-clip" [ngClass]="{'card-shadow-highlight' : shouldHighlight() }" (contextmenu)="onContextMenu($event)">
            <div class="w-full h-full">
                <a href="{{ getPreviewUrl() }}">
                    <img #previewImage class="mtg-card-rounded-sm sm:mtg-card-rounded w-full h-full" src="{{ getPreviewImageUrl() }}" [attr.loading]="loadingStrategy">
                </a>
            </div>
            <div class="absolute inset-0 grid grid-cols-3 z-10 w-full h-full items-center pointer-events-none">
                <!-- Deck & Proxy Count -->
                <div class="w-full h-full flex items-start justify-start col-span-3 pointer-events-auto">
                    <div class="w-full grid grid-cols-2 text-white">
                        <div class="flex justify-start">
                            <!-- todo deck count -->
                        </div>
                        <div class="flex justify-end">
                            @if (previewItem.collected?.proxyCount) {
                                <div class="p-3 pt-1 pb-1 bg-ponder-light rounded-bl-lg">
                                    <div>{{ previewItem.collected!.proxyCount }}</div>
                                </div>
                            } @else { 
                                <div></div>
                            }
                        </div>
                    </div>
                </div>
                <!-- Empty Space -->
                <div class="bg-red-100 col-span-3 row-span-9"></div>
                <!-- Flip Button -->
                 @if (canFlip()) {
                    <div><!-- empty --></div>
                    <div><!-- empty --></div>
                    <div class="flex text-slate-100 text-lg justify-end mr-[-1px]" [ngClass]="{'invisible' : !controlsVisible}">
                        <button (click)="onFlipClicked()" class="w-9 h-9 bg-ponder-light p-1 rounded-l-lg hover:bg-ponder-linkhover pointer-events-auto cursor-pointer">
                            <svg class="fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" stroke-width="1.5">
                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="flipSvgIcon" />
                            </svg>
                        </button>
                    </div>
                 } @else {
                    <div class="bg-red-100 col-span-3 row-span-3"></div>
                 }
                <!-- Increment / Decrement Normal Count -->
                @if (canCollectNormal()) {
                    <div class="flex text-slate-100 text-lg justify-start" [ngClass]="{'invisible' : !controlsVisible}">
                        <div class="flex flex-col gap-1">
                            <button (click)="adjustCount(1, 0, 0)" class="w-9 h-9 bg-ponder-light p-1 rounded-r-lg hover:bg-ponder-linkhover pointer-events-auto cursor-pointer">
                                <svg class="fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                </svg>
                            </button>
                            <button (click)="adjustCount(-1, 0, 0)" class="w-9 h-9 bg-ponder-light p-1 rounded-r-lg hover:bg-ponder-linkhover pointer-events-auto cursor-pointer">
                                <svg class="fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
                                </svg>
                            </button>
                        </div>
                    </div>
                } @else {
                    <div></div>
                }
                <div></div>
                <!-- Increment / Decrement Special Count -->
                @if (canCollectSpecial()) {
                    <div class="flex text-slate-100 text-lg justify-end mr-[-1px]" [ngClass]="{'invisible' : !controlsVisible}">
                        <div class="flex flex-col gap-1">
                            <button (click)="adjustCount(0, 1, 0)" class="w-9 h-9 bg-ponder-light p-1 rounded-l-lg hover:bg-ponder-linkhover pointer-events-auto cursor-pointer">
                                <svg class="fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                                </svg>
                            </button>
                            <button (click)="adjustCount(0, -1, 0)" class="w-9 h-9 bg-ponder-light p-1 rounded-l-lg hover:bg-ponder-linkhover pointer-events-auto cursor-pointer">
                                <svg class="fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
                                </svg>
                            </button>
                        </div>
                    </div>
                } @else {
                    <div></div>
                }
                <!-- Count and Value -->
                <div class="w-full h-full flex items-end justify-center col-span-3 pointer-events-auto">
                    <div class="w-full grid grid-cols-5 text-white">
                        <div class="flex justify-start">
                            @if (previewItem.collected?.count) {
                                <div class="p-3 pt-1 pb-1 bg-ponder-light rounded-tr-lg">{{ previewItem.collected!.count | number }}</div>
                            } @else { 
                                <div></div>
                            }
                        </div>
                        <div class="col-span-3 justify-center flex">
                            @if (hasAnyPrice()) {
                                <div class="flex flex-row gap-3 justify-center bg-ponder-light p-3 pt-1 pb-1 rounded-t-lg">
                                    @if (hasPrice()) { <div class="text-slate-100">{{ previewItem.price.normalUSD | currency }}</div> }
                                    @if (hasSpecialPrice()) { <div class="text-foil">{{ previewItem.price.specialUSD | currency }}</div> }
                                </div>
                            }
                        </div>
                        <div class="flex justify-end">
                            @if (previewItem.collected?.specialCount) {
                                <div class="p-3 pt-1 pb-1 bg-ponder-light rounded-tl-lg">
                                    <div class="text-foil">{{ previewItem.collected!.specialCount | number }}</div>
                                </div>
                            } @else { 
                                <div></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
</div>